import { postRequester } from '@ac/library-api/dist/api/requester';

import { DeviceIdPathParams } from '../entries';

const path = {
  keepAlive: '/kiosk/v0/devices/{deviceId}/keep-alive',
};

export const keepAlive = postRequester<DeviceIdPathParams>(path.keepAlive);
